import Link from 'next/link';

import { NotificationManager } from '@sravni/react-design-system';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { CREATE_ERROR, NOTIFICATION_TIMEOUT } from '../../constants/common';
import { EDIT, EDIT_MFO } from '../../constants/routes';
import { checkIfMfo } from '../../helpers/reviews';
import { IUserActivity } from '../../interfaces/reviews';
import { loadUserActivity } from '../../services/reviews';
import { createLinkProps } from '../../utils/routing';

import styles from './create-review.module.scss';

export const handleCreateReviewError = async (code?: 403 | 409 | 429) => {
  switch (code) {
    case 403: {
      const errorConfig = CREATE_ERROR[403];
      NotificationManager.show({
        title: errorConfig.title,
        message: errorConfig.message,
        timeout: NOTIFICATION_TIMEOUT,
      });
      break;
    }
    case 409: {
      const errorConfig = CREATE_ERROR[409];
      let userActivity: IUserActivity = null;

      try {
        userActivity = (await loadUserActivity({ pageIndex: 0, pageSize: 1 })).items[0];
      } catch (error) {
        console.error(error);
      }

      const organizationHelper = userActivity && getOrganizationHelpers(userActivity.subjectType);

      const { itemTypeUrl } = organizationHelper ?? {};

      const link =
        userActivity && organizationHelper ? (
          <Link
            {...createLinkProps('/createReview', checkIfMfo(itemTypeUrl) ? EDIT_MFO : EDIT, {
              type: itemTypeUrl,
              organization: userActivity.organizationAlias,
              id: userActivity.id,
            })}
          >
            <a>дополнить предыдущий</a>
          </Link>
        ) : (
          'дополнить предыдущий'
        );
      NotificationManager.show({
        title: errorConfig.title,
        message: (
          <div className={styles.notification}>К сожалению, пока нельзя добавить новый отзыв, попробуйте {link}</div>
        ),
        timeout: NOTIFICATION_TIMEOUT,
      });
      break;
    }
    case 429: {
      const errorConfig = CREATE_ERROR[429];

      NotificationManager.show({
        title: errorConfig.title,
        message: errorConfig.message,
        timeout: NOTIFICATION_TIMEOUT,
      });
      break;
    }
    default: {
      NotificationManager.show({
        title: CREATE_ERROR.default.title,
        message: CREATE_ERROR.default.message,
        timeout: NOTIFICATION_TIMEOUT,
      });
      break;
    }
  }
};
